/**
 * Academy domain — `AcademyCertificatesStore` state shape. Remote-only, in-memory.
 * `mine` holds the viewer's own certificates (token identity); `verificationByCode` caches
 * anonymous verification results. The producer's issued list is not state: it is served
 * page by page through `getCertificatesDataSource`.
 */
import type { CertificateResponse } from './academy.model';
import type { CertificateVerificationResponse } from './academy-responses.model';

export interface AcademyCertificatesState {
  /** The viewer's own certificates (`GET /Certificates/mine`, token identity). */
  mine: CertificateResponse[];
  /** Anonymous verification results keyed by verification code. */
  verificationByCode: Record<string, CertificateVerificationResponse>;
}

export const initialAcademyCertificatesState: AcademyCertificatesState = {
  mine: [],
  verificationByCode: {},
};
